package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Structured tag response with multilingual support (Feature 014)
 * Replaces simple string array with full tag objects
 *
 * Frontend copy with String-based UUIDs (Kotlin/JS compatible)
 */
@Serializable
data class TagResponse(
    val id: String,                             // UUID as string
    val name: String
)
